
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUnsavedChangesWarning } from "@/hooks/useUnsavedChangesWarning";

export function useNavigationHandling(form: any, translateWrapper: (key: string, fallback?: string) => string) {
  const navigate = useNavigate();
  const [showUnsavedChangesDialog, setShowUnsavedChangesDialog] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState<string | null>(null);

  // Simplified navigation without showing unsaved changes dialog
  const handleCancelWithConfirmation = () => {
    navigate("/contracts");
  };

  const confirmNavigation = () => {
    if (pendingNavigation) {
      navigate(pendingNavigation);
      setShowUnsavedChangesDialog(false);
      setPendingNavigation(null);
    }
  };

  const cancelNavigationDialog = () => {
    setShowUnsavedChangesDialog(false);
    setPendingNavigation(null);
  };

  return {
    isDirty: false, // Always return false to prevent unsaved changes warnings
    showUnsavedChangesDialog,
    setShowUnsavedChangesDialog,
    pendingNavigation,
    setPendingNavigation,
    handleCancelWithConfirmation,
    confirmNavigation,
    cancelNavigationDialog
  };
}
